export const SIZE_MAP = {
  full: 'ui-max-w-full',
  xs: 'ui-max-w-[320px]',
  sm: 'ui-max-w-[500px]',
  md: 'ui-max-w-[600px]',
  lg: 'ui-max-w-[896px]',
  xl: 'ui-max-w-[1100px]',
  '2xl': 'ui-max-w-[1350px]',
};
